import { SupportedProvider, SupportedTab } from './types';

export const DEFAULT_PROVIDER: SupportedProvider = 'twilio';
export const DEFAULT_TAB: SupportedTab = 'api-key';
